import { useSession } from "@features/session";
import { useProethicaSessionStore } from "@features/session/hooks/useProethicaSessionStore";
import { useCallback, useState } from "react";

// Mints a fresh session for an already-completed module. Goes straight to the
// formative create path to bypass the dashboard's "completed entry routes to
// its report" guard, and drops the tracked session first - the create path
// resumes a tracked session when it finds one, which would bounce the learner
// back into the old completed attempt.
export const useProethicaModuleRetake = (moduleId?: string) => {
	const { handleDirectSessionStart } = useSession();
	const [isRetaking, setIsRetaking] = useState(false);

	const handleRetakeModule = useCallback(async () => {
		if (!moduleId || isRetaking) {
			return;
		}
		setIsRetaking(true);
		try {
			useProethicaSessionStore.getState().clearModuleSession(moduleId);
			await handleDirectSessionStart({ moduleId, replace: true });
		} finally {
			setIsRetaking(false);
		}
	}, [moduleId, isRetaking, handleDirectSessionStart]);

	return { handleRetakeModule, isRetaking };
};
